module.exports = __webpack_public_path__ + "static/img/pCT5.6dbb027f.png";